import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=6d0af2e9&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=ts&"
export * from "./Investment.vue?vue&type=script&lang=ts&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=6d0af2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0af2e9",
  null
  
)

export default component.exports